export const LANG_SETLNG = 'LANG_SETLNG'
export const GOOGLE_GET_PLACE = 'GOOGLE_GET_PLACE'
